import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=4522fd78&scoped=true&"
import script from "./Links.vue?vue&type=script&setup=true&lang=js&"
export * from "./Links.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Links.vue?vue&type=style&index=0&id=4522fd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522fd78",
  null
  
)

export default component.exports